import { z } from 'zod';

import { BackgroundColor, BehaviorSettings } from '../models';
import { BasePType } from './base';
import { CardsCarouselCard } from './cards-carousel-card';
import { CtaButton } from './cta-button';

export const CardsCarousel = BasePType.extend({
  type: z.enum(['cardsCarousel']),

  behaviorSettings: z.optional(BehaviorSettings),
  bgColor: z.nullable(BackgroundColor),

  cardsCarouselCard: z.nullable(z.array(CardsCarouselCard)),
  ctaButton: z.nullable(z.array(CtaButton)),
  richTextTitle: z.string().nullable(),
});

export type CardsCarousel = z.infer<typeof CardsCarousel>;
